import * as React from 'react';

import * as styles from './styles.css';
import { clsx } from 'clsx';
import { Button, InputAdornment, MaskedInput, UIHeading1, UIText3 } from '@cian/ui-kit';

const CODE_MASK = '(000) 000 00-00';

interface ISendPhoneNumberModalContentProps {
  isPhone: boolean;
  phone: string;
  onPhoneChange: (val: string) => void;
  onSendPhoneClick: () => void;
  isDisable?: boolean;
  error: string;
}

export const SendPhoneNumberModalContent: React.FC<ISendPhoneNumberModalContentProps> = ({
  isPhone,
  phone,
  onPhoneChange,
  onSendPhoneClick,
  isDisable,
  error,
}) => {
  return (
    <div className={clsx(isPhone ? styles['container-mobile'] : styles['container'])}>
      <span className={styles['heading']}>
        <UIHeading1>Подтвердите номер, чтобы продолжить</UIHeading1>
      </span>
      <div className={styles['input']}>
        <MaskedInput
          leftAdornment={<InputAdornment>+7</InputAdornment>}
          value={phone}
          onChange={onPhoneChange}
          lazy
          size="M"
          mask={CODE_MASK}
          placeholder="Номер телефона"
        />
      </div>
      {!!error && (
        <div className={styles['error']}>
          <UIText3 color="accent-negative-primary">{error}</UIText3>
        </div>
      )}
      <div className={clsx(isPhone ? styles['button-mobile'] : styles['button'])}>
        <Button size="M" onClick={onSendPhoneClick} fullWidth={isPhone} disabled={isDisable}>
          Подтвердить
        </Button>
      </div>
    </div>
  );
};
